import { GenericDropdown, Block, Label } from '@/forms-legacy'
import { useRecurrenceWhen } from '../../../providers/StateProvider'
import { useOptions } from './useOptions'
import { useTexts } from './useTexts'
import { useOnChange } from './useOnChange'
import { createRecurrenceWhenId } from './utils/createRecurrenceWhenId'

type RecurrenceWhenDropdownProps = {
  testId?: string
}

export function RecurrenceWhenDropdown(props: RecurrenceWhenDropdownProps) {
  const { testId = 'RecurrenceWhenDropdown' } = props
  const when = useRecurrenceWhen()
  const options = useOptions()
  const onChange = useOnChange()
  const texts = useTexts()

  const selectedIds = when ? [createRecurrenceWhenId(when)] : []

  return (
    <Block data-testid={testId}>
      <Label>{texts.label}</Label>
      <GenericDropdown
        name="recurrenceWhen"
        selectedIds={selectedIds}
        values={options}
        onChanged={onChange}
      />
    </Block>
  )
}
